import { QueryClient } from '@tanstack/react-query'

/**
 * Shared QueryClient singleton.
 *
 * Lives in its own module (instead of main.tsx) so non-component code
 * — e.g. the useAuth logout flow — can clear the cache without going
 * through the useQueryClient() hook, which throws outside a
 * QueryClientProvider (unit tests, early boot). main.tsx provides this
 * same instance to the tree, so provider and direct users stay in sync.
 */
export const appQueryClient = new QueryClient()
